import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { ShowMoreWrapper, MarketGroupSection, GoToChevronIcon, HeroWidgetWrapper } from './HomepageHeroWidget.style';
import { SelectionGroup } from 'src/domains/sportsbook/shared/Components';
import { HeroWidgetModelType } from 'src/api/config/cms_new/hero_widget/get_hero_widget_active';
import { HeroWidgetItemState } from './HeroWidgetItem.state';
import { HeroWidgetBanner } from './HeroWidgetBanner';
import { HeroWidgetMainBanner } from './HeroWidgetMainBanner/HeroWidgetMainBanner';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { SelectionGroupUnified } from 'src/domains/sportsbook/webview/components/selectionsGroupUnified/SelectionGroupUnified';
import { CorrectScoreMarketGroup } from 'src/domains/sportsbook/webview/components/marketGroups/correctScoreMarketGroup/CorrectScoreMarketGroup';

interface HomepageHeroWidgetDefaultPropsType {
    heroWidgetItem: HeroWidgetModelType;
}

export const HomepageHeroWidgetDefault = observer(
    'HomepageHeroWidgetDefault',
    ({ heroWidgetItem }: HomepageHeroWidgetDefaultPropsType): JSX.Element | null => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);
        const {
            componentVariants: { sportsbookVariant },
            unifiedSportEventsTable,
        } = ConfigComponents.get(common).unifiedComponentConfig;
        const [heroWidgetItemState] = useState(() => new HeroWidgetItemState(starRouter, heroWidgetItem));
        const {
            headerImages,
            promoImages,
            marketModel,
            eventModel,
            filteredAndSortByCriteriaSelections,
            isMarketNotEmpty,
            handleRedirectTEventPage,
        } = heroWidgetItemState;
        const { is_active_promo, title, subtitle, id, tc_text, tc_title, header_bg_color } = heroWidgetItem;

        if (marketModel !== null && eventModel !== null) {
            const renderMarketGroup = () => {
                const templateId = marketModel?.newTemplateId;

                if (unifiedSportEventsTable) {
                    if (templateId.includes('correct-score')) {
                        return (
                            <CorrectScoreMarketGroup
                                market={marketModel}
                                eventId={marketModel.eventId2}
                                selections={filteredAndSortByCriteriaSelections}
                                marketId={marketModel.id2}
                                templateName={marketModel.template.name}
                            />
                        );
                    }
                    return (
                        <SelectionGroupUnified
                            isHomepage={true}
                            eventId={marketModel.eventId2}
                            marketIdMain={marketModel.id2}
                            selections={filteredAndSortByCriteriaSelections}
                        />
                    );
                }

                return (
                    <SelectionGroup
                        isHomepage={true}
                        eventId={marketModel.eventId2}
                        marketIdMain={marketModel.id2}
                        selections={filteredAndSortByCriteriaSelections}
                    />
                );
            };

            return (
                <HeroWidgetWrapper
                    key={marketModel.id}
                    variant={sportsbookVariant}
                >
                    <>
                        <HeroWidgetMainBanner
                            images={headerImages}
                            title={title}
                            subtitle={subtitle}
                            bgColor={header_bg_color}
                            onClick={handleRedirectTEventPage}
                        />
                        {isMarketNotEmpty ? (
                            <MarketGroupSection variant={sportsbookVariant}>{renderMarketGroup()}</MarketGroupSection>
                        ) : null}
                    </>
                    {unifiedSportEventsTable === false ? (
                        <ShowMoreWrapper
                            variant={sportsbookVariant}
                            onClick={handleRedirectTEventPage}
                            data-test='show-more'
                        >
                            <I18n
                                langKey='events.goto.event'
                                defaultText='Go to event'
                            />
                            <GoToChevronIcon position='right' />
                        </ShowMoreWrapper>
                    ) : null}

                    {is_active_promo ? (
                        <HeroWidgetBanner
                            withMargin={false}
                            banners={promoImages}
                            slug={`${id}-hero-promo`}
                            content={tc_text ?? ''}
                            title={tc_title ?? ''}
                        />
                    ) : null}
                </HeroWidgetWrapper>
            );
        }

        return null;
    }
);
